import { domain } from '@/Framework/config/domain';

const cookieConfig = {
  secure: domain.protocol === 'https:', // Set secured flag for cookie only if https
};

export default cookieConfig;
